import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from './components/components.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AuthModule, OidcConfigService} from 'angular-auth-oidc-client';
import { EditorModule } from '@progress/kendo-angular-editor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import {ForbiddenComponent} from './Forbidden/Forbidden.component';
import {DBConfig, NgxIndexedDBModule} from 'ngx-indexed-db';
import {APP_BASE_HREF} from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');

}

export function configureAuth(oidcConfigService: OidcConfigService) {
  return () =>
    oidcConfigService.withConfig({
      clientId: 'f3959fdc-111a-4bd8-b98d-6d262b8cf536',
      stsServer: 'https://mac.medis.land',
      responseType: 'code',
      redirectUrl: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      scope: 'openid profile apiService_53877a05-9315-4c8f-be35-edd90631d7bb offline_access',
     // logLevel: LogLevel.Debug,
    });
}

const dbConfig: DBConfig  = {
  name: 'Charity',
  version: 3,
  objectStoresMeta: [{
    store: 'Images',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'MD5', keypath: 'MD5', options: { unique: false } },
      { name: 'icon', keypath: 'icon', options: { unique: false } }]
  }]
};

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    AuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot(),
    EditorModule,
    FontAwesomeModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production, scope: '/',
      registrationStrategy: 'registerImmediately' })
  ],
  declarations: [AppComponent, AdminLayoutComponent,ForbiddenComponent],
  providers: [
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService],
      multi: true,
    }, {provide: APP_BASE_HREF, useValue: '/'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
